import { render, staticRenderFns } from "./recognize-word.vue?vue&type=template&id=57f835eb&scoped=true"
import script from "./recognize-word.vue?vue&type=script&lang=ts"
export * from "./recognize-word.vue?vue&type=script&lang=ts"
import style0 from "./recognize-word.vue?vue&type=style&index=0&id=57f835eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f835eb",
  null
  
)

export default component.exports